import dayjs from 'dayjs';

export const dates = {
  isDeadlinePassrd: (finishDate: Date): boolean => {
    const currentDate = new Date().getTime();
    const deadline = new Date(finishDate).getTime();
    return deadline < currentDate;
  },
};
